import { render } from "./KioskUserLogin.vue?vue&type=template&id=f2daf3c6"
import script from "./KioskUserLogin.vue?vue&type=script&lang=js"
export * from "./KioskUserLogin.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__